import { useState } from 'react';
import './App.css'
import CourseApplication from './components/CourseApplication';
import Footer from './components/Footer';
import ProspectingForm from './ProspectingForm';

function App() {
  const [showApplicationModal, setshowApplicationModal] = useState(false);
  const [showFaq, setshowFaq] = useState(false);
  const [showFaqone, setshowFaqone] = useState(false);
  const [showFaqtwo, setshowFaqtwo] = useState(false);
  const [showFaqthree, setshowFaqthree] = useState(false);
  const [applicationData, setapplicationData] = useState('')
  const handleCourseApplication=(field)=>{
    setshowApplicationModal(true);
    setapplicationData(field);
  }
  return (
    <>
      <div className="App">
          <nav className="nav">
            <img src="/assets/image.png" className="headerImage"  alt="Logo" />
              <a title='click to call' className='telephone' href="tel:7472498760">
                <p>&#128222;</p>
                (747) 249-8760
              </a>
          </nav>
          {showApplicationModal ?  
              <CourseApplication setshowApplicationModal={setshowApplicationModal} data={applicationData}/>
              :
            <div>
              <div className="Appbody">
                <div  className='herotester'>
                  <div className='headeroverlay'></div>
                  <header 
                    style= {{ background :"url('assets/LPBckgrd.jpg')  no-repeat ",
                            backgroundPosition: 'center',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat'
                        } }
                    >
                  </header>
                </div>
                <div className="heroContent">
                    <div className="heroContentElement">
                      <div className="heroContentElementdiv">
                        <h1 className="heroContentElementheader">
                          Become A <br/>
                          <span className="herospan">Front-End </span>
                          Developer <br/>In <span className="herospan">12+ Weeks.</span></h1>
                        <p className="heroContentParagraph">
                            Build websites, Web Applications that are Mobile responsive 
                            using in-demand skills and tools such as javascript libraries,frameworks and IDE.
                        </p>
                        <div className="heroContentDiv">
                          <p className="heroContentDivPara">
                              Our Developers have over a
                              decade Software Development experience, and background in Computer 
                              Engineering.
                            </p>
                        </div>
                      </div>
                      <div className='ctaButtonContainer'>
                        <a className='ctaButton' href='#form'>Start Your Development Journey</a>
                      </div>
                    </div>
                </div>
                </div>
                <div className="belowFold">
                <div className="objections">
                  <h1 className="objetion_heading">
                    Average Salary Of Front-End Developer
                  </h1>
                  <h2 className="objheading_two">
                    Top Jobs Availble to Front-End Dev's
                  </h2>
                  <div className="objectionVisuals">
                    <div className="objectionVisualItem">
                      <p className="objectionVisualItemPtag">Angular Developer</p>
                      <div className="objectionVisualImgContainer">
                        <img className="objectionVisualImg" src="/assets/angular.png" alt="" />
                      </div>
                        <p className="objectionVisualparagraph">$72,687</p>
                    </div>
                    <div className="objectionVisualItem">
                    <p className="objectionVisualItemPtag">Reactjs Developer</p>
                      <div className="objectionVisualImgContainer">
                        <img className="objectionVisualImg" src="/assets/reactjs.png" alt="" />
                      </div>
                      <p className="objectionVisualparagraph">$74,557</p>

                    </div>
                    <div className="objectionVisualItem">
                      <p className="objectionVisualItemPtag">UI|UX Developer</p>
                      <div className="objectionVisualImgContainer">
                        <img className="objectionVisualImg" src="/assets/uiux.png" alt="" />
                      </div>
                      <p className="objectionVisualparagraph">$65,887</p>
                    </div>
                    <div className="objectionVisualItem">
                    <p className="objectionVisualItemPtag">Javascript Developer</p>
                      <div className="objectionVisualImgContainer">
                        <img className="objectionVisualImg" src="/assets/js.png" alt="" />
                      </div>
                      <p className="objectionVisualparagraph">$68,497</p>
                    </div>

                  </div>
                  <div className='disclaimer'>
                    <p className='disclaimerPtag'>
                        Salaries based on data acquired through Indeed Februrary 2022.
                        Results are not guaranteed and may vary based on many factors 
                        including location, interview performance, experience.
                    </p>
                  </div>
                </div>
              </div>

                <div className="belowfoldsection reversecol">
                    <div id="form">
                    <ProspectingForm  cta='Submit'/>
                  </div>
                  <div className="anotherObjection mobileBorder ">
                    <h2 className="anotherObjectionH2">The learning curve is different for every student, So at 
                      <a href="https://www.softwaredevbytes.com"> Software DevBytes, </a>
                      You pick your own learning schedules.
                    </h2>
                    <p className="anotherObjectionH3">
                      Get in touch with our team of developers for available dates.
                    </p>
                    <p className="anotherObjectionH6">Complete and Submit the form</p>
                  </div>
                </div>

                <div  className="belowfoldsection  mobileBorderContainer">
                  <div className="anotherObjection mobileBorder">
                      <h2 className="anotherObjectionH2 mobileheader">No Experience Required</h2>
                    <p className="anotherObjectionH3">
                        Our comprehensive curricullum will give you the tools and 
                        knowledge you need to excel in the tech industry in as
                        little as 12 weeks.        
                      </p>
                    <p className="anotherObjectionH3">
                        But it doesn't stop there - that's why we offer extensive
                      Career Services to help you land your dream job. From 
                      resume and portfolio building to interview prep and job
                        placement assistance, we'll be there with you every 
                        step of the way. 
                      </p>
                  </div>
                  <div className="belowfoldsectionimagecontainer">
                    <img src="/assets/noexperience.jpg" className="belowfoldsectionImg twodimage" alt="softwaredevbytes" />
                  </div>
                </div>

                <div className="upcomingcourses">
                  <h2 className="upcomingcoursesH2">Upcoming Courses Start Dates</h2>
                  <h5 className="upcomingcoursesh5">Front-End Engineer and Front-End Development</h5>
                  <div className="belowfoldsection">
                    <div className="upcomingcoursesdiv">
                      <p className='upcomingPdescription'>Part Time</p>
                      <h6>April / May, 2023</h6>
                      <p className='upcomingsecondPdescription'>
                        You put in 25+ hrs/week schedule.
                      </p>
                      <button onClick={()=>handleCourseApplication('online Course')} type='submit'>Apply Now</button>
                      <p>10 Seats Remaining</p>
                    </div>
                    <div className="upcomingcoursesdiv">
                      <p className='upcomingPdescription'>Full Time</p>
                      <h6>April / May, 2023</h6>
                      <p className='upcomingsecondPdescription'>
                      You are ready to commit to a rigorous 40+ hrs/week schedule.
                      </p>
                      <button onClick={()=>handleCourseApplication('in-Person course')} type='submit'>Apply Now</button>
                      <p>10 Seats Remaining</p>
                    </div>
                    <div className="upcomingcoursesdiv">
                      <p className='upcomingPdescription'>Self-Paced</p>
                      <h6>Start Anytime</h6>
                      <p className='upcomingsecondPdescription'>
                        You work better at your own pace with a flexible format.
                      </p>
                      <button onClick={()=>handleCourseApplication('start anytime')} type='submit'>Apply Now</button>
                    </div>

                  </div>
                </div>

                <div className="faq">
                  <h2 className="faqhtwo">Frequently Asked Questions</h2>
                  <div className="faqitem">
                  <div onClick={()=>setshowFaq(!showFaq)} className="faqheading">
                      <h2>
                      Why does the Software dev bytes focus on Javascript ?
                      </h2>
                      <span>&#x25BC;</span>
                    </div>
                    {showFaq && 
                    <p className="faqItemP">
                      JavaScript is the language of the modern web. It has enabled many of the revolutionary experiences created over the past 5 years, from Google Maps to Spotify. However, historically, it has needed to be paired with something else like Python to build out full applications.

                      The emergence of server-side JavaScript means developers can now create rich, lightning-fast applications in pure JavaScript from end-to-end.

                      Focusing primarily on a single language to learn CS concepts, front-end development, and back-end development is a crucial part of what makes the extraordinary rate of learning during the program possible.
                    </p>
                    }
                  </div>
                  <div className="faqitem">
                  <div onClick={()=>setshowFaqone(!showFaqone)} className="faqheading">
                      <h2>
                      What's the difference between each of the programs?
                      </h2>
                      <span>&#x25BC;</span>
                    </div>
                    {showFaqone && 
                    <p className="faqItemP">
                    The Full-Time Front-End Curricullum runs for 3 months, and teaches a front-end JavaScript training designed to prepare residents 
                    for mid- to senior-level roles in Front-end development. Besides the timing and the location, the Front-End Curricullum is identical 
                    to the Part-Time Remote Front-End Curricullum that takes place over 16 weeks, with the same core curriculum, projects, 
                    hiring support,  and collaborative culture. 

                    Software DevBytes also offers a Data Science and Machine Learning Immersive, which launches its Beta cohort in June. 
                    You can learn more about the program and curriculum here. 

                    For more information on the differences between the programs, we welcome you to explore our 
                    <a href="https://www.softwaredevbytes.com/academy"> Academy Page.</a>  
                    </p>
                    }
                  </div>
                  <div className="faqitem">
                    <div onClick={()=>setshowFaqtwo(!showFaqtwo)} className="faqheading">
                      <h2>
                      How can I learn if Software DevBytes is right for me before I apply?
                      </h2>
                      <span>&#x25BC;</span>
                    </div>
                    {showFaqtwo && 
                    <p className="faqItemP">
                    Join our weekly JavaScript workshops, where you can learn from Software DevBytes instructors and learn alongside like-minded 
                    individuals!

                      For beginners, we recommend attending the Intro to JavaScript workshops, on Our Youtube Channel.

                      The JavaScript the Hard Parts workshops dive further under the hood, covering important yet often misunderstood 
                      concepts of JavaScript. Hard Parts are held every Thursday night also on our Youtube Channel.

                      Technical communication is a critical component of SDBytes's programs - tune into the Pair Programming sessions
                      to hone your Front-end-dev soft skills with other members of the community!

                      While our workshops run on a pretty regular cycle, you can always head over to SDBytes's YouTube channel to 
                      follow along with the workshop recordings at your own pace.

                      We welcome you to review our Community Overview page for a summary of Software DevBytes diverse community ecosystem.  
                      </p>
                    }
                  </div>
                  <div className="faqitem">
                    <div onClick={()=>setshowFaqthree(!showFaqthree)} className="faqheading">
                      <h2>
                      What makes Software DevBytes graduates stand out from other bootcamp graduates?
                      </h2>
                      <span>&#x25BC;</span>
                    </div>

                    {showFaqthree && 
                    <p className="faqItemP">
                    Year after year, Software DevBytes continues to lead in the number of graduates hired as mid- and senior-level
                    Front-end developers, as well as median starting salaries and percentage hired full-time in the Front-end world.

                    Software DevBytes's Immersive Program challenges residents to think like engineers rather than just technicians, even before
                      they are accepted; technical communication and analytical problem solving skills being at the forefront of evaluation, followed 
                      by their JavaScript knowledge.

                      This foundation continues to be built upon as residents are introduced to various approaches to develop their skills, from
                      Hack Hours and Tech Talks to several student-led projects during the program.

                      By graduation, residents are able to leverage all of these moving pieces in their job search, conveying their capabilities to 
                      succeed as leaders in the development space. Software DevBytes alumni are employed at top companies such as Amazon, Google, 
                      Netflix, and American Express, as well as other game changers in the tech space like Hulu, Hyperloop, Riot Games, and Blizzard 
                      Entertainment.

                      Learn more in this deep-dive analysis into our hiring program about how we help
                      Software DevBytes graduates get job ready for the mid and senior level roles in the tech space.
                      </p>
                    }
                  </div>
                </div>

                <div className='priceList'>
                  <div className="belowfoldsection">
                    <div className='priceListItem'>
                      <div className='priceListItemimgBox'>
                      <img className='priceListItemimg' src="/assets/priceimg1.jpg" alt="" />
                      </div>
                      <div className='priceListtopDiv'>
                      <h3>Online</h3>
                          <p>Live coding classes with your instructor and 
                            classmates.
                          </p>
                          <p>Monday-Friday 9am - 1pm PST</p>
                      </div>
                      <div className='priceListmidDiv'>
                        <p><span className='priceListspan'>&#x2713; 12 weeks:</span> Monday-Friday 9am-1pm PST</p>
                        <p><span className='priceListspan'>&#x2713; 12 Weeks:</span> Resume Reviews Until You're Hired</p>
                        <p><span className='priceListspan'>&#x2713; 12 Weeks:</span> Daily Office Hours with Your Instructor</p>
                        <p><span className='priceListspan'>&#x2713; Recorded Videos:</span> Never Miss a Minute of Class</p>
                      </div>
                      <div className='priceListbottomDiv'>
                        <p>$5,500 with installmental payments $1,840/month</p>
                        <h6>One Time Special: $5,050</h6>
                        <button type='button' onClick={()=>handleCourseApplication('online from $3,050')}>Apply for Online Classes</button>
                      </div>
                    </div>
                    <div className='priceListItem'>
                      <div className='priceListItemimgBox'>
                        <img className='priceListItemimg'  src="/assets/priceimg2.jpg" alt="" />
                      </div>
                      <div className='priceListtopDiv'>
                          <h3>In-Person</h3>
                          <p>In-Person coding classes with your instructor</p>
                          <p>Monday-Friday 9am - 1pm PST</p>
                      </div>
                      <div className='priceListmidDiv'>
                        <p><span className='priceListspan'>&#x2713; Unlimited 1:1 SUpport:</span> Meet With An Instructor<br/> Monday-Friday from 11am</p>
                        <p><span className='priceListspan'>&#x2713; 4 Labs A Week:</span>Real Life project planning</p>
                        <p><span className='priceListspan'>&#x2713; Resume Building:</span> Daily Office Hours with Your Instructor</p>
                        <p><span className='priceListspan'>&#x2713; Flexible Schedules:</span>Learning Time can be moved around</p>
                      </div>
                      <div className='priceListbottomDiv'>
                        <p>$6,850 with installmental payments $2,285/month</p>
                        <h6>One Time Special: $6,250</h6>
                        <button type='button' onClick={()=>handleCourseApplication('in-person from $6,000')}>Apply for In-Person Classes</button>
                      </div>
                    </div>
                  </div>
                </div>
              <div  className="belowfoldsection privatesessions">
                <div className="anotherObjection privatesessionstext">
                    <h2 className="anotherObjectionH2">Our Private Sessions</h2>
                  <p className="anotherObjectionH3">
                        Join us, meet our developer, and dive into the Front end curriculum.<br/>
                        We'll answer your questions and find the right path for you.
                  </p>
                    <a className='submitButton' href='#form'>Contact Our Dev Team</a>
                </div>
                  <div className="belowfoldsectionimagecontainer">
                  <img src="/assets/threescreens.jpg" className="belowfoldsectionImg" alt="softwaredevbytes" />
                </div>
              </div>
            </div>
          }
      </div>
      <Footer/>
    </>
  );
}

export default App;
